import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

// A theme that tunes its own tint for each tone (--success-subtle and the rest) gets it; otherwise a mix.
const tones = {
  neutral: "bg-surface-muted text-secondary",
  accent: "bg-accent-subtle text-accent-strong",
  success: "bg-[var(--success-subtle,color-mix(in_oklab,var(--success)_12%,transparent))] text-success",
  warning: "bg-[var(--warning-subtle,color-mix(in_oklab,var(--warning)_16%,transparent))] text-warning",
  danger: "bg-[var(--danger-subtle,color-mix(in_oklab,var(--danger)_12%,transparent))] text-danger",
  info: "bg-[var(--info-subtle,color-mix(in_oklab,var(--info)_12%,transparent))] text-info",
} as const;

/** A badge's look on another element, such as a link. */
export function badgeClass({ tone = "neutral", className }: { tone?: keyof typeof tones; className?: string } = {}) {
  return cn("inline-flex items-center rounded-pill px-2 py-0.5 text-xs font-medium no-underline", tones[tone], className);
}

export function Badge({
  tone = "neutral",
  children,
  className,
  ...rest
}: {
  tone?: keyof typeof tones;
  children: ReactNode;
  className?: string;
} & Omit<HTMLAttributes<HTMLSpanElement>, "children" | "className">) {
  return (
    <span {...rest} data-slot="badge" className={cn("inline-flex items-center rounded-pill px-2 py-0.5 text-xs font-medium", tones[tone], className)}>
      {children}
    </span>
  );
}
